// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3lbqJ","buttons":"PendingPaymentAlert_buttons__1DdPi"};